import type { IconData } from '@stacksjs/iconify-core'

export const openUmbrellaFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M21 38.724L21.5 17h5l.5 21.724C27 43.294 23.418 47 19 47s-8-3.705-8-8.276v-.76c0-1.122.65-2.137 1.763-2.272c.358-.043.77-.071 1.237-.071s.88.028 1.237.071c1.114.135 1.763 1.15 1.763 2.272v.76c0 1.143.895 2.07 2 2.07s2-.927 2-2.07\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" d=\"M26.012 2.671c-.829-1.658-3.196-1.658-4.025 0l-1.202 2.405c-5.062.772-9.55 3.299-12.91 6.575c-3.525 3.438-5.916 7.81-6.351 12.047c-.133 1.295.425 2.649 1.686 3.362C5.511 28.362 11.222 30.5 24 30.5s18.489-2.138 20.79-3.44c1.26-.713 1.819-2.067 1.686-3.362c-.435-4.237-2.826-8.609-6.351-12.047c-3.36-3.276-7.848-5.803-12.91-6.575z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default openUmbrellaFlat
